//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    data () {
        return {
            environment_node_env: process.env.NODE_ENV,
            environment: process.env.VUE_APP_ENVIRONMENT,
            host: window.location.host
        }
    },
    computed: {
        persistedSelectedDecades() { 
            return localStorage.getItem('selectedDecades') 
        }
    },
    methods: {
        reset: function() {
            console.log("Reset History")

            localStorage.setItem('selectedDecades', '')
        
            localStorage.playerplayedCount = ''
            localStorage.setItem('playerplayed', '')
            localStorage.question1Count = ''
            localStorage.question2Count = ''
            localStorage.question3Count = ''
            localStorage.legendsCount = ''
            localStorage.setItem('legends', ''),
            localStorage.krampenCount = ''
            localStorage.setItem('krampen', '')
            localStorage.datapatch_version = ''
        },
        resetUser: function() {
            localStorage.setItem('uuid', '')
        }
    }
}
